// extracted by css-extract-rspack-plugin
export default {"dialog":"Walmart-module__dialog___sFahT","container":"Walmart-module__container___VM8w9","containerMobile":"Walmart-module__containerMobile___Pu0IK"};